/*
KITS_INSTRUMENT is a list of all the instruments that are available in the kits:
*/
export const KITS_INSTRUMENT = {
  Audio: 'Audio',
  Bass: 'Bass',
  '808': '808',
  'Bass Guitar': 'Bass Guitar',
  'Synth Bass': 'Synth Bass',
  Drums: 'Drums',
  Kick: 'Kick',
  Clap: 'Clap',
  Crash: 'Crash',
  Ride: 'Ride',
  Cymbal: 'Cymbal',
  Hat: 'Hat',
  Percussion: 'Percussion',
  Tom: 'Tom',
  Keys: 'Keys',
  Organ: 'Organ',
  Piano: 'Piano',
  Guitar: 'Guitar',
  Cello: 'Cello',
  'Double Bass': 'Double Bass',
  Harp: 'Harp',
  Violin: 'Violin',
  Strings: 'Strings',
  'Analog Synth': 'Analog Synth',
  'Synth Lead': 'Synth Lead',
  Arp: 'Arp',
  Synth: 'Synth',
  Pad: 'Pad',
  Vocals: 'Vocals',
  Phrases: 'Phrases',
  Brass: 'Brass',
  Wind: 'Wind',
  Soundscape: 'Soundscape',
  SFX: 'SFX',
  Snare: 'Snare'
}
